import { Injectable, PLATFORM_ID, Signal, inject, signal } from '@angular/core';
import { AES, enc } from 'crypto-ts';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private remembar = {
    KEY: 'bts_course_auth02',
    PASSWORD: '!##0895*()?:}95047834&&tesdsfdsfsdf@EWdsd'
  };

  private TEMP = {
    KEY: 'bts_course_auth',
    PASSWORD: '90590348534YYIU!@00asfdadsf@£sxfcdf'
  };

  private USER: Signal<{ KEY: string, PASSWORD: string }> = signal({
    KEY: 'bts_course_auth0',
    PASSWORD: '!##0895*()?:}95047834&&tes12323?ADSLklo'
  });

  private cookie = inject(CookieService);

  // DECRYPT THE COOKIES DATA BEFORE SAVE
  public encryption(data: any, secret: string) {
    return AES.encrypt(JSON.stringify(data), secret);
  }

  // DECRYPT THE COOKIES DATA
  private decryption(data: any, secret: string) {
    const bytes = AES.decrypt(data.toString(), secret);
    return JSON.parse(bytes.toString(enc.Utf8));
  }

  //  SAVE USER COOKIES DATA OR LOGIN THE USER
  async setUser(data: any) {
    return this.cookie.set(this.USER().KEY, this.encryption(data, this.USER().PASSWORD).toString(), 7, '/', '', false, 'Strict');
  }

  // GET SAVED USER COOKIES DATA
  getUser() {
    const DATA = this.cookie.get(this.USER().KEY) !== null ? this.cookie.get(this.USER().KEY) : undefined;
    if (DATA) return this.decryption(DATA, this.USER().PASSWORD)
    return false
  }

  // CLEAR USER COOKIES DATA OR LOGOUT THE USER
  clearUser() {
    this.cookie.delete(this.USER().KEY, '/');
    this.cookie.delete(this.USER().KEY, '/user');
    this.cookie.delete(this.USER().KEY, '/user/*');
  }

  getDataField(type: string) {
    return this.getUser() && this.getUser()[type];

  }

  // DETECT USER'S TOKEN IS AVAILABLE OR NOT
  isAuthenticate(): boolean {
    return !!this.getDataField('token');
  }
}
